import { SEGMENTS } from '@sparknz/journeys-common';

import { MetaTagsProps } from 'shared/components/MetaTags';

const LANDING_PATH = 'store-finder';
const META_DESCRIPTION =
  'Find a Spark retail store near your area with address and contact details.';

export const LANDING_PAGE_META_DATA = {
  title: 'Find your nearest Spark store',
  description: META_DESCRIPTION,
  segment: SEGMENTS.PERSONAL,
  canonicalUrl: LANDING_PATH,
};

export interface StoreFinderMetaData {
  locationId: string;
  locationName: string;
  serviceType: string;
}

export function constructStoreFinderMetaData({
  locationId,
  locationName,
  serviceType,
}: StoreFinderMetaData): MetaTagsProps {
  return {
    title: `${locationName}`,
    description: META_DESCRIPTION,
    segment: SEGMENTS.PERSONAL,
    canonicalUrl: `${LANDING_PATH}/${serviceType}/${locationId}/`,
  };
}
